import { useMutation, useQuery } from "@apollo/client";
import { toaster } from "evergreen-ui";
import { auth } from "firebase";
import React, { useEffect, useState } from "react";
import { CHECK_BY_USERNAME } from "src/Queries/users.shared";
import { INSERT_USER } from "./SetupUplineMutation";
import SetupUplinePresenter from "./SetupUplinePresenter";

interface IProps {
  uplineUsername: any;
  refetch: any;
  country: any;
}
const SetupUpline: React.SFC<IProps> = ({
  uplineUsername,
  refetch,
  country,
}) => {
  const [search, setSearch] = useState(uplineUsername.value !== "");
  const [isLoading, setIsLoading] = useState(false);
  const { data, loading, error } = useQuery(CHECK_BY_USERNAME, {
    variables: {
      username: uplineUsername.value.replace(" ", ""),
    },
    skip: uplineUsername.value === "" || !search,
  });

  const [insertUser] = useMutation(INSERT_USER);

  const onChange = (e) => {
    setSearch(false);
    uplineUsername.onChange(e);
  };

  const submitSearch = (e) => {
    e.preventDefault();
    setSearch(true);
  };

  useEffect(() => {
    if (error) {
      return toaster.danger(error.message);
    }
    if (
      !loading &&
      data &&
      data.users.length <= 0 &&
      uplineUsername.value !== ""
    ) {
      return toaster.danger("No agent found!");
    }
  }, [data, loading, error, uplineUsername.value]);

  const closeSearch = () => {
    setSearch(false);
  };

  const onSubmit = () => {
    setIsLoading(true);
    insertUser({
      variables: {
        object: {
          id: auth().currentUser?.uid,
          email: auth().currentUser?.email,
          upline: data.users[0].id,
        },
      },
    })
      .then(() => {
        toaster.success("Referral saved!");
        refetch().then(() => {
          setIsLoading(false);
        });
      })
      .catch((e) => {
        toaster.danger(e.message, { duration: 30000 });
      });
  };
  return (
    <SetupUplinePresenter
      onSubmit={onSubmit}
      loading={loading || isLoading}
      closeSearch={closeSearch}
      uplineUsername={uplineUsername}
      onChange={onChange}
      country={country}
      showBox={
        data && data.users && data.users.length > 0 && data.users[0] && search
      }
      upline={
        (data && data.users && data.users.length > 0 && data.users[0]) || null
      }
      submitSearch={submitSearch}
    />
  );
};

export default SetupUpline;
